import { ViewModel,View, ObservableArray } from "binder"
import  { WarehouseKeepingListView } from "./warehouseKeepingList-view"
import { ServerConnection } from "src/server/serverConnection";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseKeepingDetailViewModel } from "../warehouseKeepingDetail/warehouseKeepingDetail-viewModel";
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WarehouseSelectorViewModel } from "src/Warehouse/warehouseManipulation/warehouseManipulation-viewModel";
import { CreateWarehouseKeepingViewModel } from "../createWarehouseKeeping/createWarehouseKeeping-viewModel";
import { downloadFile } from "src/uicomponents/components/utilities";

export class WarehouseKeepingListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'انبارگردانی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehouseKeepings = ObservableArray.create<WarehouseKeeping>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseKeepingListView();
    }
    public getTypeId(): string {
        return "VM-1FCE2CFC-D013-4137-93A8-3DA1120284FB"
    }
    public set warehouseKeepings(v: ObservableArray<WarehouseKeeping>) { this._warehouseKeepings = v; } public get warehouseKeepings(): ObservableArray<WarehouseKeeping> { return this._warehouseKeepings;} private _warehouseKeepings: ObservableArray<WarehouseKeeping>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.refreshPaged();
    }
    async refreshPaged(): Promise<any>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/ListWarehouseKeeping',{
            });
            this.warehouseKeepings.update(...result.Keepings.map((q,i)=>{
                let r = new WarehouseKeeping(this);
                r.rowNumber = i+1;
                r.warehouseKeepingId = q.Id;
                r.createTime = moment.utc(q.From);
                r.endTime = q.Until==null ? null : moment.utc(q.Until);
                r.warehouseId = q.WarehouseId;
                r.warehouseName = q.WarehouseName;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    refreshClosePopups() {
        this.isShowingPopup = false;
        this.refresh();
    }
    
    async showDetail (id:string) {
        let keepingDetail = new WarehouseKeepingDetailViewModel(this, id);
        let result = await this.showPopup(keepingDetail);
    }
    
    async createWarehouseKeeping() {
        let newForm = new CreateWarehouseKeepingViewModel(this);
        let result = await this.showPopup(newForm);
        if(result=='done')
            this.refresh();
    }
    
    async createWarehouseKeepingReport() {
        let ids = this.warehouseKeepings.filter(x=>x.isSelected).map(x=>x.warehouseKeepingId);
        if(ids.length==0){
            this.messageBoxConfirmWarning("هیچ انبارگردانی انتخاب نشده است.","خطا")
            return;
        }
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/GetWarehouseKeepingCumulativeReport',{
                KeepingIds : ids
            });
            if(result.IsSuccessful){
                downloadFile(result.ExcelData,"کزارش انبارگردانی.xlsx")
            }else{
                this.messageBoxConfirmWarning("خطا در انجام عملیات","خطا")
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("خطا در انجام عملیات","خطا")
        } finally {
            this.isLoading = false;
        }
    }
}

export class WarehouseKeeping extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingListViewModel) {
        super(parent);
        this._typedParent = parent;
        this.isSelected = false;
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
    private _typedParent:WarehouseKeepingListViewModel;

    async showDetail(){
        this._typedParent.showDetail(this.warehouseKeepingId);
    }  

}

